export const ADMIN = 'ADMIN';
export const ADMINLAB = 'ADMINLAB';
export const ANALIS = 'ANALIS';
// export const APPADMIN = 'APPADMIN';
export const WILKER = 'WILKER';
export const WILKERSPV = 'WILKERSPV';
export const PELAKSANATEKNIS = 'PELAKSANATEKNIS';

